/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class AuthenticationSettings extends PageStringSection {
    button_save_label: string = "Labels.lbl_Save";
    buttonGroup_ssoProvider_azure_label: string = "Labels.lbl_SsoProvider_Azure";
    buttonGroup_ssoProvider_label: string = "Labels.lbl_SsoProvider";
    buttonGroup_ssoProvider_okta_label: string = "Labels.lbl_SsoProvider_Okta";
    buttonGroup_ssoProvider_adfs_label: string = "Labels.lbl_SsoProvider_Adfs40";
    formItem_accountName_label: string = "Labels.lbl_AccountName";
    formItem_appId_label: string = "Labels.lbl_AppId";
    formItem_appSecret_label: string = "Labels.lbl_AppSecret";
    formItem_authorizationServer_label: string = "Labels.lbl_AuthorizationServer";
    formItem_clientId_label: string = "Labels.lbl_ClientId";
    formItem_clientSecret_label: string = "Labels.lbl_ClientSecret";
    formItem_organizationUrl_label: string = "Labels.lbl_OrganizationUrl";
    formItem_tenantName_label: string = "Labels.lbl_TenantName";
    formItem_usernamePropertyName_label: string = "Labels.lbl_UsernamePropertyName";
    message_Save_Failure: string = "Messages.msg_FailedToSave";
    message_Save_Sucess: string = "Messages.msg_FailedToSave";
    radio_authenticationMethods_both_option: string = "Labels.lbl_AuthenticationMethods_Both";
    radio_authenticationMethods_label: string = "Labels.lbl_AuthenticationMethods";
    radio_authenticationMethods_singleSignOn_option: string = "Labels.lbl_AuthenticationMethods_SingleSignOn";
    radio_authenticationMethods_usernameAndPassword_option: string = "Labels.lbl_AuthenticationMethods_UsernameAndPassword";
}
